<template>
	<v-btn
		@click="onClick"
		:color="color"
		:disabled="disabled"
		:loading="loading"
		:to="to"
		fab
		fixed
		:top="top"
		:bottom="!top"
		:left="left"
		:right="!left"
		style="z-index: 10;"
	>
		<v-icon>{{icon}}</v-icon>
	</v-btn>
</template>

<script>
export default {
	props: {
		color: String,
		disabled: Boolean,
		loading: Boolean,
		to: Object,
		icon: String,
		top: Boolean,
		left: Boolean,
	},
	methods: {
		onClick(event) {
			this.$emit('click', event)
		},
	},
}
</script>
